import { isPresent } from "@/lib/utils"
import vuexStore from "@/store"
import Emitter from "tiny-emitter"

export const MVT_EVENTS = {
  PAGE_VIEW: "page_view",
  LOGIN: "login",
  LOGGED_IN: "loggedIn",
  LOGGED_OUT: "loggedOut",
  SIGN_UP: "sign_up",
  FORM_SUBMIT: "form_submit",
  SEARCH: "search",
  BUTTON_CLICK: "button_click",
  CONTENT_ERROR: "content_error",
  NAVIGATION_ITEM_CLICK: "navigation_item_click",
  LINK_CLICK: "link_click",
  FEED_JOIN: "feed_join",
  FILE_DOWNLOAD: "file_download",
  TELEPHONE_CLICK: "telephone_click",
  EMAIL_CLICK: "email_click",
  VIDEO_START: "video_start",
  VIDEO_WATCH: "video_watch",
  SOCIAL_CLICK: "social_click",
  PRODUCT_PURCHASED: "product_purchased",
  PROPS_UPDATED: "propsUpdated"
} as const

export class EventManager {
  private readonly emitter: any
  private readonly unwatchers: any[] = []

  LOGGED_IN = MVT_EVENTS.LOGGED_IN
  LOGGED_OUT = MVT_EVENTS.LOGGED_OUT
  PROPS_UPDATED = MVT_EVENTS.PROPS_UPDATED

  constructor() {
    this.emitter = new (Emitter as any)()
    this._initializeAuthWatcher()
  }

  on(event: string, callback: (...args: any[]) => void): void {
    this.emitter.on(event, callback)
  }

  once(event: string, callback: (...args: any[]) => void): void {
    this.emitter.once(event, callback)
  }

  off(event: string, callback?: (...args: any[]) => void): void {
    if (callback) {
      this.emitter.off(event, callback)
    } else {
      this.emitter.off(event)
    }
  }

  emit(event: string, ...args: any[]): void {
    this.emitter.emit(event, ...args)
  }

  destroy(): void {
    this.unwatchers.forEach(unwatcher => unwatcher())
    this.emitter.off()
  }

  private _initializeAuthWatcher(): void {
    const unwatcher = vuexStore.watch(
      (_: any, getters: { [key: string]: any }) => getters["auth/currentUser"],
      (user: { id: string; name: string; email: string } | null) =>
        this.emit(
          isPresent(user) ? MVT_EVENTS.LOGGED_IN : MVT_EVENTS.LOGGED_OUT,
          user
        )
    )
    this.unwatchers.push(unwatcher)
  }
}
